module.exports = __webpack_public_path__ + "static/startPage-c16f3777b6d874c612091e41bf0b14fb.jpeg";